import { FC } from 'react'

type IconTriangleLeftProps = {
  className?: string
}

export const IconTriangleLeft: FC<IconTriangleLeftProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 12 24"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.626817 11.3215C0.272888 11.7046 0.27289 12.2954 0.626819 12.6786L10.2654 23.1127C10.883 23.7812 12 23.3443 12 22.4341L12 1.56588C12 0.655746 10.883 0.218788 10.2654 0.887328L0.626817 11.3215Z"
        fill="#999999"
      />
    </svg>
  )
}
